export default "__VITE_ASSET__BeIusM70__"